// extracted by mini-css-extract-plugin
export var border = "_1a-8";
export var brand = "_1a-t";
export var button = "_1a-l";
export var center = "_1a-a";
export var centered = "_1a-6";
export var closeButton = "_1a-c";
export var disabledWrapper = "_1a-m";
export var error = "_1a-p";
export var extraLarge = "_1a-4";
export var extraSmall = "_1a-1";
export var fill = "_1a-i";
export var footer = "_1a-h";
export var footerAction = "_1a-j";
export var footerButtons = "_1a-k";
export var header = "_1a-7";
export var headerWithClose = "_1a-d";
export var icon = "_1a-o";
export var info = "_1a-s";
export var inline = "_1a-9";
export var large = "_1a-3";
export var main = "_1a-e";
export var modal = "_1a-0";
export var nearFull = "_1a-5";
export var neutral = "_1a-u";
export var noPadding = "_1a-g";
export var none = "_1a-v";
export var scrollable = "_1a-f";
export var small = "_1a-2";
export var success = "_1a-r";
export var tight = "_1a-n";
export var titleIcon = "_1a-b";
export var warn = "_1a-q";